<script lang="ts">
  import { INSTALL_REFERRER } from "@/constants/constants";
  import profileStore from "@/stores/profile";
  import clsx from "clsx";
  import { onMount } from "svelte";
  import InstallButton from "./InstallButton.svelte";
  export let intentUrl = "";
  export let source = "";
  export let isVideoFeed = false;
  export let btnClass = "";

  let showBanner = true;
  const referrer = isVideoFeed
    ? INSTALL_REFERRER.TOPBAR
    : INSTALL_REFERRER.BOTTOMBAR;

  onMount(() => {
    showBanner = $profileStore.isTempAuth;
  });
</script>

{#if showBanner}
  <div
    class={clsx(
      "z-[2] px-xs left-0 right-0  flex justify-between mdUp:text-mmd font-bold items-center bottom-14",
      !isVideoFeed && "bg-black absolute py-xs h-[50px]"
    )}
  >
    {#if !isVideoFeed}
      <div class="flex items-center text-white">
        <!-- <img class="rounded-2xl" alt="MojLogo" src={MojLogo} /> -->
        <div class="pl-xms">Get full experience on the Moj App</div>
      </div>
    {/if}
    <InstallButton {intentUrl} {referrer} style={btnClass} {source} />
  </div>
{/if}
